module.exports = __webpack_public_path__ + "img/40.90484ae0.png";